<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      observer: null,
      splitUrl: "",
      isVideoPlaying: false,
    };
  },
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.observer = new IntersectionObserver(this.playVideo, {
      threshold: 0,
    });
  },
  mounted() {
    this.$refs.videoP;
    this.setObserver();
  },
  computed: {
    ...mapState(["modalAttr"]),
    videoURL() {
      const srcStr = this.video.url;
      return srcStr.split(/v\d{5,12}/);
    },
  },
  methods: {
    setObserver() {
      this.observer.observe(this.$refs.videoP);
    },

    playVideo(entries) {
      const vm = this;
      entries.forEach(function (video) {
        if (video.isIntersecting === true) {
          for (const source in video.target.children) {
            const videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
            video.target.load();
            if (video.target.dataset.id === vm.activeVideo) {
              video.target.play();
              vm.isVideoPlaying = true;
            }
          }
        } else {
          //TODO validate if the video is playable then pause it

          video.target.pause();
          vm.isVideoPlaying = false;
          video.currentTime = 0;
        }
      });
    },
  },
  watch: {
    modalAttr: {
      handler() {
        if (this.modalAttr.isModalOpen === true) {
          this.$refs.videoP.pause();
        } else if (
          this.modalAttr.isModalOpen === false &&
          this.isVideoPlaying === true
        ) {
          this.$refs.videoP.play();
        }
      },
      deep: true,
    },
  },
};
</script>
<template>
  <video muted loop playsinline ref="videoP" :poster="`${videoURL[0]}so_0${videoURL[1]}.jpg`">
    <source :data-src="`${videoURL[0]}q_90/vc_h265/w_1920/c_limit${videoURL[1]}.mp4`" type="video/mp4; codecs=hvc1" />
    <source :data-src="`${videoURL[0]}q_90/vc_vp9/w_1920/c_limit${videoURL[1]}.webm`" type="video/webm; codecs=vp9" />
    <source :data-src="`${videoURL[0]}q_90/w_1920/c_limit${videoURL[1]}.mp4`" type="video/mp4" />
  </video>
</template>
<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

video {
  width: 100%;
}

@include mq($until: sm) {
  video {
    --gridPadding: 30px;
    width: calc(100% + var(--gridPadding) * 2);
    margin-left: calc(-1 * var(--gridPadding));
    border-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppVideoPlayerwithObserver.vue